import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { CaseSubject } from './caseSubject';


@JsonObject('CaseSubjectSearchResults')
export class CaseSubjectSearchResults extends SearchResults {
    @JsonProperty('results', [CaseSubject])
    results: CaseSubject[] = [];
}